import CallDashboardFrame from "pages/audioServices/callDashboardNew";
import Settings from "pages/audioServices/settings";
import { lazy } from "react";

const CallDashboard = lazy(() => import("pages/audioServices/CallDashboard"));

const callerRoute = [
  {
    path: "/call-dashboard-new",
    isExact: true,
    component: CallDashboardFrame,
  },
  {
    path: "/call-dashboard",
    isExact: true,
    component: CallDashboard,
  },

  {
    path: "/call-settings",
    isExact: true,
    component: Settings,
  },
];

export default callerRoute;
